import {Grid} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import {useCouponDeactivateRequest} from '@yandex-taxi/react-integration-api'
import React from 'react'

import {classes} from './Coupon.classes'

type CouponType = {
  title: string
  code: string
  selected?: boolean
  error?: {
    description: string
  }
}

type Props = {
  coupon: CouponType
}

const Coupon: React.FC<Props> = ({coupon}) => {
  const t = useI18n()

  const [deactivateHandler] = useCouponDeactivateRequest()
  const title = coupon.title.replace('$SIGN$$CURRENCY$', 'руб.').replace('<b>', '').replace('</b>', '')

  return (
    <Grid className={classes.coupon} container>
      <Grid direction="row" justify="flex-end" xs={12} container item>
        <Grid item>
          <button className={classes.smallRemoveButton} onClick={() => deactivateHandler(coupon.code)}>
            ✕
          </button>
        </Grid>
      </Grid>
      <Grid className={classes.couponTitle} xs={9} item>
        {coupon.code}
      </Grid>
      {coupon.selected && (
        <Grid xs={3} item>
          {t('order.form.coupons.active_coupon', 'Активный')}
        </Grid>
      )}
      <Grid className={classes.couponDescription} xs={6} item>
        {title}
      </Grid>
      {coupon.error && (
        <Grid className={classes.couponError} xs={6} item>
          {coupon.error.description}
        </Grid>
      )}
    </Grid>
  )
}

export default Coupon
